import React, { Component, createRef } from 'react';
import 'flatpickr/dist/themes/light.css';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { english } from 'flatpickr/dist/l10n/default';
import { IDateTimeFormik } from '../../../models/components/input-date-time';
import Translator from '../../../core/i18n';
import IsValidComponent from '../text/validate-input';
import flatpickr from 'flatpickr';
import { getIn } from 'formik';
import { Log } from 'ng2-logger';
import Moment from 'moment';

const T = Translator.create();
const _logger = Log.create('date-time-formik');

export class DatetimeFormik extends React.Component<IDateTimeFormik> {
    public picker: HTMLInputElement | null = null;

    constructor(props: any) {
        super(props);
    }
    state = {
        mainComponentId: 'main_'+this.props.datePickerId
    }

    public componentDidMount = () => {
        
        this.setFlatPicker(this.props.datePickerId);
        if (this.props.isTouchedOnDidMount) {
            this.props.formik.setFieldTouched(this.props.name, true);
        }
    };

    public isFilled() {
        const value = this.props.setValue ? this.props.setValue : getIn(this.props.formik.values, this.props.name);
        return value && value !== '';
    }

    public onChangeSetFlatPicker(e: Date[]) {
        if (this.picker) {
            let date = '';
            if (this.props.mode === 'time') {
                date = this.picker.value;
            } else {
                date = Moment(e[0]).locale('en')
                    .format(this.getDateFormat())
                    .toString();
                if (e.length > 1) {
                    date =
                        date +
                        ' - ' +
                        Moment(e[1])
                            .format(this.getDateFormat())
                            .toString();


                }
            }
            this.props.formik.setFieldValue(this.props.name, date);
        }
    }

    public getDateFormat() {
        return this.props.mode !== 'time' && !this.props.enableTime
            ? this.props.dateFormat
                ? this.props.dateFormat
                : window.appSettings.DefaultDateFormat
            : this.props.mode !== 'time' && this.props.enableTime
                ? (this.props.dateFormat ? this.props.dateFormat : window.appSettings.DefaultDateFormat) + ' H:i'
                : this.props.mode === 'time'
                    ? 'H:i'
                    : '';
    }

    public getDefaultSelectedDate() {
        const date: Date[] = [];
        const inputDate = this.props.setValue ? this.props.setValue : getIn(this.props.formik.values, this.props.name);
        switch (this.props.mode) {
            case 'single':
                date.push(new Date(Moment(inputDate, this.getDateFormat()).format()));
                break;
            case 'time':
                date.push(
                    new Date(
                        Moment(inputDate, this.getDateFormat())
                            .set({
                                h: Moment(inputDate, window.appSettings.DefaultDateTimeFormat).get('hour'),
                                m: Moment(inputDate, window.appSettings.DefaultDateTimeFormat).get('minute')
                            })
                            .format(window.appSettings.DefaultDateFormatApi)
                    )
                );
                break;
            case 'range':
                date.push(
                    new Date(Moment(inputDate.substring(0, 10), this.getDateFormat()).format(window.appSettings.DefaultDateFormat))
                );
                date.push(
                    new Date(
                        Moment(inputDate.substring(13, inputDate.length), this.getDateFormat()).format(
                            window.appSettings.DefaultDateFormat
                        )
                    )
                );
                break;
            default:
                date.push(new Date());
                break;
        }
        return date;
    }



    setIdToTimeInputs = () => {
        const {  minDate, maxDate } = this.props;
     
        const input = document.getElementById(this.state.mainComponentId)?.querySelector('.numInput.cur-year')
        if (!input) {
            return
        }
               
                input.addEventListener('input', (e) => {
                    const target = e.target;
    
                    if (target instanceof HTMLInputElement) {
                        const value = Number(target.value);
    
                        if (this.props.minDate) {
                            const minYear = Moment(minDate).year();
                            if (value < minYear) {
                                target.value = minYear.toString();
                            }
                        }
    
                        if (this.props.maxDate) {
                            const maxYear = Moment(maxDate).year();
                            if (value > maxYear) {
                                target.value = maxYear.toString();
                            }
                        }
                    }
                });
    };

    public setFlatPicker = (inputid: string) => {
        let _static = false;
        if (this.props.static !== undefined) {
            _static = this.props.static;
        }
        if (this.picker) {
            flatpickr('#' + inputid, {
                static: _static,
                minDate: this.props.minDate ? Moment(this.props.minDate).toDate() : '',
                maxDate: this.props.maxDate ? Moment(this.props.maxDate).toDate()  : '',
                maxTime: this.props.maxTime ? Moment(this.props.maxTime).toDate() : '',
                minTime: this.props.minTime ?  Moment(this.props.minTime).toDate() : '',
                time_24hr: this.props.time24Hr !== undefined ? this.props.time24Hr : true,
                locale: T.i18next.language === 'ar' ? english : T.i18next.language === 'en' ? english : Turkish,
                dateFormat: this.getDateFormat(),
                mode: this.props.mode ? this.props.mode : 'single',
                allowInput: false,
                clickOpens: true,
                enableTime: this.props.enableTime ? this.props.enableTime : this.props.mode === 'time' ? true : false,
                defaultDate: this.getDefaultSelectedDate(),
                onChange: e => this.onChangeSetFlatPicker(e),
                onReady: (selectedDates, dateStr, instance) => {
                    this.setIdToTimeInputs();
                },
                altInputClass: this.props.flatPickrClass ? this.props.flatPickrClass : '',
                position: 'auto',
            });

            let elemInput = document.getElementById(this.props.datePickerId) as HTMLInputElement;
            if(elemInput)
            {
                elemInput.value =getIn(this.props.formik.values, this.props.name);
            }

        }
    };

    clear = () => {
        if (this.picker) {
            this.picker.value = '';
            this.props.formik.setFieldValue(this.props.name, '');
            setTimeout(() => {
                this.setFlatPicker(this.props.datePickerId);
            }, 500);
        }
    };

    public render() {
        return (
            <div id={this.state.mainComponentId} className={`${this.props.className ? this.props.className : 'form-input form-group date-picker'} ${this.isFilled() ? 'filled' : ''}`}>
                <input
                    name={this.props.name}
                    readOnly={true}
                    autoComplete={'off'}
                    ref={e => (this.picker = e)}
                    id={this.props.datePickerId}
                    onBlur={this.props.formik.handleBlur}
                    placeholder={this.props.placeHolder ? this.props.placeHolder : ''}
                    onChange={this.props.formik.handleChange}
                    value={this.props.setValue ? this.props.setValue : getIn(this.props.formik.values, this.props.name)}
                />
                {(this.props.isClearable && this.picker && this.picker.value) || (this.props.dataClearable) ? (
                    <a onClick={this.clear} className='date-close-button' style={{ position: 'absolute', top: '25%' }}>
                        <i className="material-icons">clear</i>
                    </a>
                ) : (
                    ''
                )}
                <IsValidComponent
                    value={this.props.setValue ? this.props.setValue : getIn(this.props.formik.values, this.props.name)}
                    isSubmitting={this.props.formik.submitCount}
                    errors={getIn(this.props.formik.errors, this.props.name)}
                    touched={getIn(this.props.formik.touched, this.props.name)}
                />
                {this.props.label ? <label>{this.props.label}</label> : null}
            </div>
        );
    }
}
